<template>
    <div class="a-form-inputs o-filter-options">
        <div class="o-filter-options__box o-filter-options__box-header u-d-flex flex-state-buttons" :class="{'o-filter-options__box-closed' : !show}">
            <div class="u-d-flex u-margin-bottom-10">
                <div>
                    <h2 class="u-no-margin">{{ title }}</h2>
                </div>
            </div>
        </div>

        <div v-if="!justAdvanced" class="o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap">
            <div class="flex-grid__g-3 u-flex-grow-none" v-if="!advancedSearchVisible">
                <component
                    is="InputFilter"
                    name="searchText"
                    :update="filter"
                >
                </component>
            </div>
            <div class="flex-grid__g-1" v-if="!advancedSearchVisible">
                <button class="a-button a-button--small u-no-margin" @click="submit">
                    Search
                </button>
                <button class="a-button a-button--small u-no-margin" @click="advancedSearch">
                    Advanced Search
                </button>
            </div>
        </div>

        <div v-if="advancedSearchVisible || justAdvanced">
            <div class="o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap">
                <div v-for="(data, index) in filters.filterTypes" class="flex-grid__item--third">
                    <component
                        :is="data.component"
                        :filter-heading="data.filterHeading" 
                        :from="data.from" 
                        :to="data.to"
                        :option-values="data.values"
                        :date="data.date"
                        :pound="data.pound"
                        @boxToDelete="deleteBox = $event"
                        :name="data.name"
                        :update="filter"
                        ref="filterInputs"
                        v-if="data.name !== 'searchText'"
                    >
                    </component>
                </div>
            </div>
        </div>

        <div class="u-d-flex u-flex-space-between" v-if="advancedSearchVisible || justAdvanced">
            <button class="a-button a-button--small a-button--loader-button" @click="submit"
            :disabled="running" :class="[running ?'a-loader--white':'']">
                <span :class="[running ? 'a-button--span-hidden' : '']">
                    {{ buttonTitle }}
                </span>
            </button>
            <div>
                <button class="a-button a-button--small" @click="doReset()">
                    Reset
                </button>
                <button class="a-button a-button--small u-no-margin" @click="advancedSearch">
                    Simple Search
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import InputFilter from 'components/filter/filterTypes/InputFilter.vue';
    import MonetaryRangeFilter from 'components/filter/filterTypes/MonetaryRangeFilter.vue';
    import RangeFilter from 'components/filter/filterTypes/RangeFilter.vue';
    import SelectFilter from 'components/filter/filterTypes/SelectFilter.vue';
    import OptionList from 'components/OptionList.vue';

    export default {
        name: 'filter-options',
        components: {
            InputFilter,
            MonetaryRangeFilter,
            RangeFilter,
            SelectFilter,
            OptionList,
        },
        props: {
            title: {
                type: String,
                default: "Claim Filter",
            },
            buttonTitle: {
                type: String,
                default: "Search",
            },
            running: {
                type: Boolean,
                default: false,
            },
            justAdvanced: {
                type: Boolean,
                default: false
            },
            // Callback Props
            action: {},
            reset: {},
            filter: {},
        },
        data: function () {
            return {
                advancedSearchVisible: false,
                selectedListItem: 'hi',
                defaultFilterHeading: 'Please select a claim filter and click the add button',
                deleteBox: '',
                currentMenu: '',
                filterBoxes: [],
                show: true,
                filterCounter: 0,
                filters: {
                    filterTypes: [
                        {
                            component: 'SelectFilter',
                            name: 'claimStatus',
                            filterHeading: 'Claim Status',
                            values: {
                                'All Claims': null,
                                'Live Claims': true,
                                'Concluded Claims': false,
                            },
                        },
                        {
                            component: 'SelectFilter',
                            name: 'claimType',
                            filterHeading: 'Claim Type',
                            values: {
                                 'Fatal Accident Dependency' : 'fatal_accident_dependency',
                                 'Fatal Accident Estate' : 'fatal_accident_estate',
                                 'Lost Years' : 'lost_years',
                                 'Personal Injury' : 'personal_injury',
                            },
                        },
                        // {
                        //     component: 'SelectFilter',
                        //     filterHeading: 'Disease Type',
                        //     name: 'diseaseType',
                        //     values: {
                        //         'Mesothelioma': 'Mesothelioma',
                        //         'Asbestos Related Lung Cancer': 'Asbestos Related Lung Cancer',
                        //         'Nasal Cancer': 'Nasal Cancer',
                        //         'Bladder Cancer': 'Bladder Cancer',
                        //         'Skin Cancer': 'Skin Cancer',
                        //         'Laryngeal Cancer': 'Laryngeal Cancer',
                        //         'Kidney Cancer': 'Kidney Cancer',
                        //         'Liver Cancer': 'Liver Cancer',
                        //         'Leukemia': 'Leukemia',
                        //         'Other Cancer': 'Other'
                        //     },  
                        // },
                        {
                            component: 'SelectFilter',
                            filterHeading: 'Discount Rate',
                            name: 'discountRate',
                            values: {
                                 '-2.00%': '-2',
                                 '-1.50%': '-1.5',
                                 '-1.00%': '-1',
                                 '-0.75%': '-0.75',
                                 '-0.50%': '-0.5',
                                 '-0.25%': '-0.25',
                                 '0.00%': '0',
                                 '0.50%': '0.5',
                                 '1.00%': '1',
                                 '1.50%': '1.5',
                                 '2.00%': '2',
                                 '2.50%': '2.5',
                                 '3.00%': '3',
                            },
                        },
                        {
                            component: 'SelectFilter',
                            filterHeading: 'Deceased/Injured Gender',
                            name: 'gender',
                            values: {
                                'Male': 'male',
                                'Female': 'female'
                            },
                        },
                        {
                            component: 'RangeFilter',
                            filterHeading: 'Age at Death',
                            name: 'ageAtDeath',
                            from: '',
                            to: '',
                        },
                        {
                            component: 'SelectFilter',
                            filterHeading: 'Number of Dependants',
                            name: 'numberOfDependants',
                            values: {
                                '1': 1,
                                '2': 2,
                                '3': 3,
                                '4': 4,
                                '5': 5
                            }
                        },
                        {
                            component: 'SelectFilter',
                            filterHeading: 'Child Dependants',
                            name: 'numberOfChildDependants',
                            values: {
                                '1': 1,
                                '2': 2,
                                '3': 3,
                                '4': 4,
                                '5': 5
                            }
                        },
                        {
                            component: 'SelectFilter',
                            filterHeading: 'Employed at Death',
                            name: 'employedAtDeath',
                            values: {
                                'Yes': true,
                                'No': false,
                            }
                        },
                    ]
                }
            }
        },
        methods: {
            /**
             * Fire off the user action callback. 
             */
            submit() {
                this.action(this);
            },
            /**
             * Fire off the reset filters and then trigger the reset
             * callback provided as a prop. The parent Vue may wish to 
             * do something as part of the reset process.
             */
            doReset() {
                this.$refs.filterInputs.forEach((component) => {
                    component.reset();
                });

                this.reset();
            },
            toggle() {
                this.show = !this.show;
            },
            updateFilter(e) {
                this.currentMenu = e.target
            },
            advancedSearch() {
                this.reset();
                return this.advancedSearchVisible = !this.advancedSearchVisible;
            },
        },
        mounted: function() {
            if (!this.action) {
                throw {'error': 'No action prop defined for FilterOptions. Unable to handle request.'};
            }

            if (!this.reset) {
                throw {'error': 'No reset prop defined for FilterOptions. Unable to reset for subsequent requests.'};
            }

            if (!this.filter) {
                throw {'error': 'No filter prop defined for FilterOptions. Unable to apply filters.'};
            }

            this.filterBoxes = document.querySelectorAll('.o-filter-options__box .filterInputs');
        }
    }
</script>


// WEBPACK FOOTER //
// FilterOptions.vue?50a65c9e